import Navbar from '@/components/Navbar';
import HeroSection from '@/components/HeroSection';
import TwoPathwaySection from '@/components/TwoPathwaySection';
import FeaturesSection from '@/components/FeaturesSection';
import DetailedNursesSection from '@/components/DetailedNursesSection';
import EmployersSection from '@/components/EmployersSection';
import AboutSection from '@/components/AboutSection';
import WestbalkanSection from '@/components/WestbalkanSection';
import RecognitionSection from '@/components/RecognitionSection';
import ProcessSection from '@/components/ProcessSection';
import ContactFormSection from '@/components/ContactFormSection';
import ContactCTA from '@/components/ContactCTA';
import Footer from '@/components/Footer';
import { useLanguage } from '@/lib/i18n';
import { useSeo } from '@/hooks/useSeo';

const Index = () => {
  const { lang } = useLanguage();

  const seoContent = {
    de: {
      title: 'ViaMedica Balkan | ANU und Vermittlung fur Pflege in Deutschland',
      description:
        'ViaMedica Balkan verbindet Pflegekrafte und Arbeitgeber mit zwei Modellen: Arbeitnehmeruberlassung (ANU) fur flexible Einsatze und Direktvermittlung fur langfristige Besetzungen.',
    },
    bs: {
      title: 'ViaMedica Balkan | ANU i posredovanje za zdravstveni sektor u Njemackoj',
      description:
        'ViaMedica Balkan povezuje medicinske radnike i poslodavce kroz dva modela: ANU za fleksibilne potrebe i direktno posredovanje za dugorocne timove.',
    },
    en: {
      title: 'ViaMedica Balkan | Temporary Staffing and Placement for Healthcare in Germany',
      description:
        'ViaMedica Balkan connects healthcare professionals and employers through two models: temporary staffing (ANU) for flexible demand and direct placement for long-term staffing.',
    },
  };

  const seo = seoContent[lang as keyof typeof seoContent] || seoContent.de;

  useSeo({
    title: seo.title,
    description: seo.description,
    canonical: 'https://www.via-medica-balkan.de/',
    keywords:
      'ViaMedica Balkan, ANU, Arbeitnehmeruberlassung, Personalvermittlung, Direktvermittlung, Pflegekrafte, Deutschland, Arbeitgeber, Gesundheitswesen',
  });

  return (
    <div className="min-h-screen">
      <Navbar />
      
      {/* Hero Section */}
      <HeroSection />
      
      {/* Clear pathway selection and navigation */}
      <TwoPathwaySection />
      
      {/* General features for both paths */}
      <FeaturesSection />
      
      {/* Path-specific sections */}
      <DetailedNursesSection />
      <EmployersSection />
      
      {/* Common company information */}
      <AboutSection />
      <WestbalkanSection />
      
      {/* Recognition: Recognition nur fÃ¼r bs */}
      {lang === 'bs' && <RecognitionSection />}
      
      {/* Contact and conversion sections */}
      <ContactFormSection />
      <ContactCTA />

      <section className="py-6">
        <div className="container mx-auto px-4">
          <p className="text-center text-xs text-muted-foreground">
            {lang === 'de'
              ? 'Mitglied im GVP Gesamtverband der Personaldienstleister (GVP).'
              : lang === 'bs'
                ? 'Clan GVP-a (Gesamtverband der Personaldienstleister).'
                : 'Member of GVP (Gesamtverband der Personaldienstleister).'}
          </p>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default Index;



